import { CommonModule, isPlatformServer } from '@angular/common';
import { Component, inject, PLATFORM_ID, REQUEST_CONTEXT } from '@angular/core';

import { DirectivesModule } from '@jht/brand-directives';
import { TranslateModule } from '@jht/brand-translate';
import { RequestContext } from '../shared/utils/models';

@Component({
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [CommonModule, DirectivesModule, TranslateModule],
})
export class PageNotFoundComponent {
    constructor() {
        const platformId = inject(PLATFORM_ID);
        const context = inject(REQUEST_CONTEXT, {
            optional: true,
        }) as RequestContext | null;

        if (isPlatformServer(platformId) && context) {
            context.status = 404;
        }
    }
}
